import { css, useTheme } from '@emotion/react';
import { Icon } from '~/components/atomic';
import { useAssetStoreState } from '~/store';

export default function Refresh() {
  const theme = useTheme();
  const { setSelectedMotion, setAnimationState } = useAssetStoreState(
    (state) => ({
      setSelectedMotion: state.setSelectedMotion,
      setAnimationState: state.setAnimationState,
    }),
  );

  const handleClick = () => {
    setAnimationState({ type: 'Idle' });
    setSelectedMotion('');
  };

  return (
    <div
      css={css`
        position: absolute;
        right: ${theme.layout.section_side};
        bottom: ${theme.layout.section_side};

        & > button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          border-radius: 16px;
          background: ${theme.backgroundColor.bg_light_5_alpha};
        }
      `}
    >
      <button onClick={handleClick}>
        <Icon color='content_light_1' size={24} iconName={'Reload'} />
      </button>
    </div>
  );
}
